import React, { useState } from "react";
import styles from "./ota-drawer-markdown-support.module.scss";
import { MarkdownSupportPopover } from "@src/components/molecules/markdown-support-popover/markdown-support-popover";

import QuestionMarkIcon from "@src/assets/svg/question-mark-full-gray-12.svg";
import MarkDownIcon from "@src/assets/svg/markdown-icon.svg";
import { useI18N } from "@src/language/language-context";

const cssClassName = "ota-drawer-markdown-support";
const OtaDrawerMarkDownSupport = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const i18n = useI18N();
  const texts = {
    documentationText: i18n(
      "modules.otaDrawerMarkDownSupport.documentationText",
    ),
    markDownSupportedText: i18n(
      "modules.otaDrawerMarkDownSupport.markDownSupportedText",
    ),
  };
  return (
    <>
      <p className={styles[`${cssClassName}__documentation-label`]}>
        {texts.documentationText}
      </p>
      <div className={styles[`${cssClassName}__markdown`]}>
        <div className={styles[`${cssClassName}__markdown-label`]}>
          <img src={MarkDownIcon} alt={"Markdown"} />
          <p className={styles[`${cssClassName}__markdown-supported`]}>
            {texts.markDownSupportedText}
          </p>
        </div>
        <img
          src={QuestionMarkIcon}
          alt="Question Mark"
          width={20}
          height={20}
          onPointerEnter={() => setIsPopoverOpen(true)}
          onPointerLeave={() => setIsPopoverOpen(false)}
        />
        {isPopoverOpen && <MarkdownSupportPopover />}
      </div>
    </>
  );
};

export default OtaDrawerMarkDownSupport;
